import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useLazyQuery } from '@apollo/react-hooks';
import { GoogleAdsWithInsights, GoogleAdsWithInsightsVariables } from './__generated__/GoogleAdsWithInsights';

const GOOGLE_ADS_WITH_INSIGHTS_QUERY = gql`
  query GoogleAdsWithInsights($filter: AdsFilterInput!, $dateRange: DateRangeInput!) {
    googleAds(filter: $filter) {
      id
      resourceName
      status
      googleAdGroup {
        id
        resourceName
        googleCampaign {
          resourceName
          article {
            id
            url
            title
            campaignId
            articleGroup {
              id
            }
          }
        }
      }
      googleInsights(dateRange: $dateRange) {
        clicks
        impressions
        cost
        cpc
        cpm
        ctr
      }
    }
  }
`;

export const useGoogleAdsWithInsightsQuery = () => {
  return useLazyQuery<GoogleAdsWithInsights, GoogleAdsWithInsightsVariables>(GOOGLE_ADS_WITH_INSIGHTS_QUERY, {
    client: kmsClient,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};
